import { useLanguage } from "../context/LanguageContext";
import { ASSETS, NEW_DOMAIN, OLD_DOMAIN } from "../config";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="relative" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 border-b bp-border py-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={ASSETS.newLogoIcon}
                alt="XPDC"
                className="h-10 w-10 object-contain"
              />
              <div>
                <p className="font-display text-xl leading-none">XPDC</p>
                <p className="mt-1 font-mono-x text-[10px] uppercase tracking-[0.15em] text-muted-x">
                  {t.footer.company}
                </p>
              </div>
            </div>
            <p className="mt-6 font-display text-2xl uppercase tracking-tight">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-muted-x">
              DOMAIN STATUS
            </p>
            <div className="mt-4 space-y-2 font-mono-x text-sm">
              <p className="flex items-center justify-between">
                <span className="line-through opacity-60">{OLD_DOMAIN}</span>
                <span className="text-muted-x">DEPRECATED</span>
              </p>
              <p className="flex items-center justify-between">
                <span style={{ color: "var(--xp-primary)" }}>{NEW_DOMAIN}</span>
                <span
                  className="flex items-center gap-2"
                  style={{ color: "var(--xp-accent)" }}
                >
                  <span
                    className="inline-block h-2 w-2 animate-blink"
                    style={{ background: "var(--xp-accent)" }}
                  />
                  INCOMING
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-2 py-6 font-mono-x text-[10px] uppercase tracking-[0.2em] text-muted-x md:flex-row">
          <span>
            &copy; {year} {NEW_DOMAIN}
          </span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
